var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M12 1C5.4 1 0 5.5 0 11s5.4 10 12 10c1 0 2-.1 3-.3l5.6 2.2c.1 0 .2.1.4.1s.4-.1.6-.2c.3-.2.4-.6.4-.9l-.5-4.7c1.6-1.8 2.5-3.9 2.5-6.1C24 5.5 18.6 1 12 1z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }